import React from "react";
import banner1 from "../../assets/img/about/banner1.png";
import { Button } from "react-bootstrap";
function Aboutus() {
  return (
    <div className="bg-all-container bg-black">
      <div className="flex flex-col items-center justify-center mb-20 mt-32 gap-2">
        {/* <div className="Content-Wrapper flex">
          <img className="banner-img" src={banner1} alt="" />
          <div className="Text-wrapper">
            <h2>Tentang Nero Games</h2>
            <p style={{color:'white'}}>
            Selamat datang di Nero Games ID, tujuan utama Anda untuk game online berbasis web dan layanan top-up game mobile. Kami bersemangat tentang dunia game dan berdedikasi untuk memberikan pengalaman terbaik bagi para gamer.
            </p>
          </div>
        </div>

        <div className="Content-Wrapper banner2">
          <h2>Game Online Berbasis Web</h2>
          <p style={{color:'white'}}>
          Di Nero Games ID, kami menawarkan beragam pilihan game online berbasis web yang cocok untuk semua jenis pemain. Apakah Anda menyukai strategi, aksi, atau game kasual, platform kami menyediakan sesuatu untuk semua orang. Nikmati permainan tanpa hambatan langsung dari browser Anda tanpa perlu mengunduh atau menginstal apapun.
          </p>
        </div> */}

        <div className="Row">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
            className="Content-Wrapper w-100"
          >
            <div class="bg-white p-6 rounded-lg shadow-md max-w-lg text-center">
              <h1 class="text-2xl font-bold text-blue-500">
                Arcadia - Top Up Game Cepat & Transparan
              </h1>
              <p class="mt-4 text-gray-700">
                Bermain game jadi lebih menyenangkan jika saldo selalu siap!{" "}
                <strong>Arcadia</strong> adalah layanan top up yang mengutamakan{" "}
                <strong>kenyamanan</strong> dan <strong>kecepatan</strong>.
              </p>
              <p class="mt-2 text-gray-700">
                Tidak ada lagi menunggu lama atau harga yang tidak masuk akal –
                di sini, semuanya <strong>transparan</strong> dan{" "}
                <strong>kompetitif</strong>.
              </p>
              <p class="mt-2 text-gray-700">
                Dengan dukungan transaksi otomatis, berbagai metode pembayaran,
                dan banyak promo menarik, Arcadia siap menjadi teman setia dalam
                petualangan gaming-mu.
              </p>

              <h2 class="mt-4 text-lg font-semibold">
                🔹 Kenapa Pilih Arcadia?
              </h2>
              <ul class="mt-3 text-left text-gray-700 space-y-2">
                <li>
                  ⚡ <strong>Transaksi Otomatis</strong> – Saldo langsung masuk
                  tanpa delay.
                </li>
                <li>
                  💰 <strong>Harga Kompetitif</strong> – Tidak ada biaya
                  tersembunyi.
                </li>
                <li>
                  🎁 <strong>Promo Menarik</strong> – Dapatkan diskon dan
                  cashback setiap hari.
                </li>
              </ul>

              <a
                href="#"
                class="mt-6 inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-300"
              >
                Isi Saldo Sekarang 🎮
              </a>
            </div>
          </div>
          <div className="Content-Wrapper w-100 m-0-10">
            <img src="https://storage.googleapis.com/urban-g-assets/home/mlbb-kof.png" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aboutus;
